export enum EAuditTrailAction {
  INSERT = "INS",
  UPDATE = "UPD",
  DELETE = "DEL",
  CONFIG = "COF",
  PRINT = "PRT",
  SCAN_EMPLOYEE = "SEM",
  SCAN_PRODUCT_LOT = "SPL",
  SCAN_CUSTOMER = "SCM",
  SCAN_PALLET = "SP",
  SCAN_CARTON = "SCT",
  SCAN_PRODUCT = "SPD",
  SCAN_END = "SED",
  SCAN_DESTROY_LABEL = "SDL",
  SCAN_DESTROY_LABEL_END = "SDLE",
  SCAN_DESTROY_LABEL_FORCE_END = "SDLFE",
  SCAN_TAKE_SAMPLE = "STS",
  SCAN_TAKE_SAMPLE_END = "STSE",
  SCAN_BARCODE_INVALID = "SBI",
  SCAN_EXPORT_NOTE = "SEN",
  SCAN_SPLIT_NOTE = "SSN",
  SCAN_PREPARE_NOTE = "SPN",
  SCAN_DELIVERY_NOTE = "SDN",
  SCAN_DRIVER_SIGN = "SDS",
  PRINT_CARTON_LABEL = "PCL",
  PRINT_PALLET_LABEL = "PPL",
  EXPORT_CARTON_BARCODE = "ECB",
  EXPORT_PRODUCT_BARCODE = "EPB",
  GENERATE_CARTON_BARCODE = "GCB",
  GENERATE_PRODUCT_BARCODE = "GPB",
  AUTO_RECEIVE_PRODUCT = "ARP",
  LOGIN = "Login",
}
